document.addEventListener("DOMContentLoaded", function (event) {

  // header dropdown
  var toggaleButton = document.querySelectorAll(".slide-nav__button");
  toggaleButton.forEach((btn) => {
    btn.addEventListener("click", function (e) {
      this.classList.toggle("slide-active");
      var element = this.closest(".slide-nav__item").querySelector(
        ".slide-nav__dropdown"
      );
      element.classList.toggle("is-active");
    });
  });

  // collection filter
  var dropdown = document.querySelectorAll(".collection_filter .collapsible-trigger");
  dropdown.forEach((btn) => {
    btn.addEventListener("click", function (e) {
      this.classList.toggle("is-open");
      var element = this.closest(".collection_filter").querySelector(
        ".collection_filter .collapsible-content"
      );
      element.classList.toggle("is-open");
    });
  });

  var menu_dropdown = document.querySelectorAll(".tag__checkbox-wrapper.col_link_clr");
  menu_dropdown.forEach((btn) => {
    btn.addEventListener("click", function (e) {
      this.classList.toggle("is-open");
      var element = this.closest(".col_nav.first_level").querySelector(
        ".sub_col_slist"
      );
      element.classList.toggle("is-open");
    });
  });

  if(document.querySelectorAll('.quickmodal .product__thumb-item') != null){
    document.querySelectorAll('.quickmodal .product__thumb-item').forEach( thumb =>{
      thumb.addEventListener('click', function() {   
  
        this.parentElement.querySelectorAll(".product__thumb").forEach(function(evtt){
          evtt.classList.remove("is-active");
        });
        
        var thumbSrc = thumb.querySelector('img').getAttribute('src');    
        var mediaSrc = document.querySelector('.quickmodal .product-image-main').querySelector('img');
        mediaSrc.setAttribute('src',thumbSrc);
  
        thumb.querySelector('a').classList.add('is-active');
      });
    });
  }

});

// product grid item slider

function productSlider() {
  var elem = document.querySelectorAll(".featured_cl_slider");
  elem.forEach((gallery) => {
    var flkty = new Flickity(gallery, {
      watchCSS: true,
      pageDots: false,
      prevNextButtons: true,
      contain: true,
      groupCells: true,
      cellAlign: 'left',
    });
    var width = window.innerWidth;
    if (width <= 1023) {
      flkty.destroy();
    }
  });
}

// Cart Recommendation Product
function itemSlider() {
  var elem = document.querySelectorAll(".r-product-grid");
  elem.forEach((gallery) => {
    var flkty = new Flickity(gallery, {
      watchCSS: true,
      pageDots: false,
      prevNextButtons: true,
      contain: true,
      groupCells: true,
      cellAlign: 'left',
    });
    var width = window.innerWidth;
    if (width <= 1023) {
      flkty.destroy();
    }
  });
}

productSlider();
itemSlider();

window.addEventListener(
  "resize",
  function (event) {
    productSlider();
    itemSlider();
  },
  true
);